import React from 'react';
import CMSFormHidden from './CMSFormHidden';
import CMSFormImage from './CMSFormImage';
import CMSFormDate from './CMSFormDate';
import CMSFormInput from './CMSFormInput';
import CMSFormTextArea from './CMSFormTextArea';
import CMSFormRichText from './CMSFormRichText';
import CMSFormSelect from './CMSFormSelect';
import CMSFormRadioButtons from './CMSFormRadioButtons';
import CMSFormCheckBoxes from './CMSFormCheckBoxes';
import CMSFormColor from './CMSFormColor';


const CMSFormController = (props) => {
    const { control } = props
    switch (control) {
        case "hidden":
            return <CMSFormHidden {...props} />
        case "input":
            return <CMSFormInput {...props} />
        case "date":
            return <CMSFormDate {...props} />
        case "image":
            return <CMSFormImage {...props} />
        case "textArea":
            return <CMSFormTextArea {...props} />
        case "richText":
            return <CMSFormRichText {...props} />
        case "select":
            return <CMSFormSelect {...props} />
        case "colorPicker":
            return <CMSFormColor {...props} />
        case "boolean":
            return <CMSFormSelect
                {...props}
                options={[
                    { label: "Yes", value: "1" },
                    { label: "No", value: "0" },
                ]}
            />
        case "radio":
            return <CMSFormRadioButtons {...props} />
        case "checkbox":
            return <CMSFormCheckBoxes {...props} />

        default:
            return null
    }
};

export default CMSFormController;
